import React from 'react';

const ButtonDarkBlue = () => {

  return (
    <>
        <button className='form-input-btn darkblue' type='submit'>
          Generuj Stopkę
        </button>
    </>
  );
};

export default ButtonDarkBlue;